import React, { useEffect, useState } from 'react'
import { Text, View, TextInput, StyleSheet, Alert, Image } from 'react-native'
import { Feather } from '@expo/vector-icons'
import { FormFieldsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import { TouchableOpacity } from 'react-native-gesture-handler'
import * as ImagePicker from 'expo-image-picker'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { uploadData, getUrl } from 'aws-amplify/storage'
import { PhotoModal } from '../FormItems/InputPhotoItem'
import { getImageStogeUrl, getUrlSave } from '../../imageUploader/ImageStorage'
import styles from '../FormItems/InputPhotoItemStyles'
import theme from '../../../../theme'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import { eventEmitter, get_url_save_photo, validateConnectionNetwork } from '../../../utils/functions.utils'
import { getConection } from '../../appBar/context/HeaderContext'

interface InputPhotoFieldProps {
    item: FormFieldsModel
    hasCamera: boolean
    hasGalery: boolean
    form_id: string
    schedule_id: string
    store_id: string
    answerProp: ModelAnswerFromProps
    checkComplete: (option?: ModelAnswerFromProps) => void
    saveItemSteps?: (option: ModelAnswerFromProps) => void
}

export const InputPhotoField = ({
    item,
    hasCamera,
    hasGalery,
    form_id,
    answerProp,
    schedule_id,
    store_id,
    checkComplete,
    saveItemSteps,
}: InputPhotoFieldProps) => {
    // const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [image, setImage] = useState<string | null>(null)
    const { isConnected, hasInternet } = getConection()
    const placeHolder = require('../../../../assets/placeholderImage.png')

    useEffect(() => {
        if (answerProp?.field_media !== '') {
            // console.log('22-------- tengo respuesta old: InputPhotoField', answerProp)

            setImage(answerProp?.field_media || null)
        } else {
            //   console.log('26-------- no tengo respuesta old')
        }
    }, [])

    const handleImagePickerResult = async (photoUri: string) => {
        eventEmitter.emit('process_start_image')
        if (photoUri) {
            let answer: ModelAnswerFromProps = null
            try {
                const res_get_url_save_photo = get_url_save_photo('/stores/form')
                const filename = res_get_url_save_photo
                if (saveItemSteps) {
                    answerProp = item as any
                }
                answer = {
                    _id: answerProp?._id,
                    option_selected_text: answerProp?.option_selected_text,
                    option_selected_id: answerProp?.option_selected_id,
                    question_id: answerProp?.question_id,
                    media: '',
                    question_text: answerProp?.question_text,
                    score: answerProp.score ? answerProp.score.toString() : '0',
                    status: 1,
                    date_finish: new Date().toString(),
                    date_init: new Date().toString(),
                    question_input: '',
                    field_media: '',
                    field_text: '',
                    questionScore: answerProp.questionScore,
                    index: answerProp.index,
                    type: answerProp.type,
                    ponderar: answerProp.questionScore && answerProp.questionScore > 0, //[7, 8, 14, 18].includes(answerProp.type),

                    question: answerProp?.question_text,
                    questionOptionSelected: answerProp?.option_selected_id,
                    questionOptionSelectedText: answerProp?.option_selected_text,
                    questionType: answerProp.questionType,
                    questionPrice: '',
                    tag: '',
                    questionImage: '',
                    questionInput: '',

                    sku: answerProp.sku,
                    description: answerProp.description ?? '',
                    description_short: answerProp.description_short ?? '',
                }

                answer.field_media = filename
                answer.media = filename
                answer.questionImage = filename
                answer.pickerResult_uri = photoUri

                setImage(placeHolder)
                const isConnected = await validateConnectionNetwork()
                // if (isConnected) {
                //     const response = await fetch(photoUri)
                //     if (!response.ok) {
                //         throw new Error('115 Error al subir la imagen')
                //     }
                //     const blob = await response.blob()
                //     const resp_img = await getUrlSave(filename, photoUri)
                //     console.log('🚀 ~ handleImagePickerResult ~ resp_img:', resp_img)
                //     if (resp_img) {
                //         answer.media = resp_img.imageUrlDB ?? res_get_url_save_photo
                //         answer.questionImage = resp_img.imageUrlDB ?? res_get_url_save_photo
                //         answer.pickerResult_uri = resp_img.imageUrlDB ?? res_get_url_save_photo

                //         onPicture(resp_img.imageUrl)
                //     }
                // }
                if (form_id) {
                    setImage(isConnected ? answer.media : placeHolder)

                    await checkComplete(answer)
                } else {
                    console.log('estoy en el caso de checkin')
                }
            } catch (error) {
                console.error('12 Error al subir la imagen:', error)
                eventEmitter.emit('process_end_image')
            } finally {
                try {
                    if (saveItemSteps) {
                        saveItemSteps(answer)
                    } else {
                        updateFormAnswerSchedule({ newAnswer: answer, schedule_id, form_id, store_id })
                        await checkComplete(answer)
                    }
                } catch (e) {
                    eventEmitter.emit('process_end_image')
                    Alert.alert('Error', 'No se pudo subir la imagen', e)
                }
            }
        }
        eventEmitter.emit('process_end_image')
    }

    const onPicture = (image: string) => {
        // closeBottomSheet(true)
    }

    return (
        <>
            {!image && (
                <View style={styles.container}>
                    <PhotoModal hasCamera={hasCamera} hasGalery={hasGalery} handleImagePickerResult={handleImagePickerResult} />
                </View>
            )}
        </>
    )
}
